<script setup lang="ts">
import {CustomerSignIn, CustomerSignInStatus, useWebPopup, WebForm, WebInput} from "lct-lib";
import GoogleSignIn from "./GoogleSignIn.vue";
import {onMounted, ref} from "vue";
import {storeToRefs} from "pinia";
import {customerStore} from "../customer.store";
const {show, hide} = useWebPopup();
const email = ref();
const password = ref();

const {customer} = storeToRefs(customerStore());


const signIn = async () => {
    try {
        show();
        const result:any = await CustomerSignIn("email", email.value, password.value);
        customer.value = result.data;
        show("You have successfully logged in.", ()=>{
            location.href = "/";
        });
    } catch (e) {
        hide();
        console.error(e);
    }

}

</script>

<template>
<div c2c-0 class="cc">
    <div v-if="!customer" c2c-1 class="w-100%-max:500 h-500">
        <div c2c-2 class="cc p-20-12">
            <h1 class="cc">Sign In</h1>
        </div>

        <div c2c-3 class="sd bg-0 p-12 br-6 m-12 bd">
            <web-form c2c-4 class="m_end" @submit="signIn">
                <web-input label="Email" v-model="email" required></web-input>
                <web-input label="Password" type="password" v-model="password" required></web-input>
                <button c2c-5 class="w-100% btl-blue">Sign in</button>
            </web-form>
        </div>

        <p c2c-6 class="tc">Or</p>
        <div c2c-7 class="p-12">
            <GoogleSignIn></GoogleSignIn>
        </div>
        <div c2c-8 class="p-12 tc">
            Don’t have an account? <a c2c-9 class="c-logo tb" href="/sign-up">Sign up here.</a>
        </div>
    </div>
    <div c2c-10 class="h-min:600" v-else>
        <p c2c-11 class="p-30-12 fs-19 tb">You are logging in.</p>
    </div>
</div>
</template>

<style scoped>

</style><style lang="scss" scoped>.cc[c2c-0] {
                        display: flex; flex-direction: column; align-items: center;
                 }.w-100\%-max\:500[c2c-1] {
                        width: 100%;max-width: 500px;
                 }.h-500[c2c-1] {
                        height: 500px;
                 }.cc[c2c-2] {
                        display: flex; flex-direction: column; align-items: center;
                 }.p-20-12[c2c-2] {
                        padding-top: 20px;padding-right: 12px;padding-bottom: 20px;padding-left: 12px;
                 }.sd[c2c-3] {
                        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.2)
                 }.bg-0[c2c-3] {
                        background-color: hsl(0, 0%, 100%);
                 }.p-12[c2c-3] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.br-6[c2c-3] {
                        border-top-left-radius: 6px;border-top-right-radius: 6px;border-bottom-right-radius: 6px;border-bottom-left-radius: 6px;
                 }.m-12[c2c-3] {
                        margin-top: 12px;margin-right: 12px;margin-bottom: 12px;margin-left: 12px;
                 }.bd[c2c-3] {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.w-100\%[c2c-5] {
                        width: 100%;
                 }.tc[c2c-6] {
                        text-align: center;
                 }.p-12[c2c-7] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.p-12[c2c-8] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.tc[c2c-8] {
                        text-align: center;
                 }.c-logo[c2c-9] {
                        color: hsl(197.39999999999998, 95.9%, 38%);
                 }.tb[c2c-9] {
                        font-weight: bold;
                 }.h-min\:600[c2c-10] {
                        min-height: 600px;
                 }.p-30-12[c2c-11] {
                        padding-top: 30px;padding-right: 12px;padding-bottom: 30px;padding-left: 12px;
                 }.fs-19[c2c-11] {
                        font-size: 19px;
                 }.tb[c2c-11] {
                        font-weight: bold;
                 }</style>